import { render } from "./CobrancaUsuario.vue?vue&type=template&id=35546528&ts=true"
import script from "./CobrancaUsuario.vue?vue&type=script&lang=ts"
export * from "./CobrancaUsuario.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__